import { Mic, Volume2 } from 'lucide-react';

export default function Memory({ transcript, status, taskState }) {
  // Показываем ТОЛЬКО последнее распознанное слово — и оно исчезает, когда
  // начинается распознавание следующего. Список ранее названных пациенту
  // не показываем: зачёт виден врачу в отчёте (и счётчиком снизу).
  const lastFound = taskState?.found?.[taskState.found.length - 1] || null;

  return (
    <div className="flex flex-col items-center z-10 gap-4 w-full max-w-2xl">
      <h2 className="text-2xl md:text-3xl font-semibold text-muted-foreground text-center z-10 max-w-3xl min-h-[60px] flex items-center">
        Прослушайте слова и повторите их
      </h2>
      {status === 'speaking' && <Volume2 className="size-12 text-accent animate-pulse" />}
      {status === 'listening' && (
        <div className="flex flex-col items-center gap-4 w-full">
          <Mic className="size-12 text-red-500 animate-bounce" />
          <div className="px-8 py-6 bg-secondary rounded-3xl border-2 border-red-500/30 text-center min-h-[120px] flex items-center justify-center w-full">
            {lastFound ? (
              <span className="text-3xl text-primary font-medium capitalize">{lastFound}</span>
            ) : (
              <span className="text-2xl text-muted-foreground/50">Слушаю…</span>
            )}
          </div>
          <p className="text-sm text-muted-foreground">Вспомнено: {taskState?.found?.length || 0} из 5</p>
        </div>
      )}
    </div>
  );
}